import { Grid, Stack, SxProps } from "@mui/material";
import Box from "@mui/material/Box";
import { ReactNode } from "react";

interface ViewGridLayoutProps {
  Header?: ReactNode;
  LeftColumn: ReactNode;
  RightColumn: ReactNode;
  containerSx?: SxProps;
}

const ViewGridLayout = ({ Header, LeftColumn, RightColumn, containerSx }: ViewGridLayoutProps) => (
  <Stack spacing={2.5}>
    {Header && (
      <Stack
        direction='row'
        justifyContent='space-between'>
        {Header}
      </Stack>
    )}
    <Box>
      <Grid
        container
        spacing={2.5}
        sx={containerSx}>
        <Grid
          item
          xs={12}
          md={9}>
          {LeftColumn}
        </Grid>
        <Grid
          item
          xs={12}
          md={3}>
          {RightColumn}
        </Grid>
      </Grid>
    </Box>
  </Stack>
);

export default ViewGridLayout;
